import { Api } from '@axiom/ui';
import type { User, MfaPhoneNumber, MfaVerification } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class AuthUsersApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.portalApiUrl,
    });
  }

  async updateMfaPhoneNumber(userId: User['id'], body: MfaPhoneNumber) {
    return super.write<{ data: never }>({
      endpoint: `/users/${userId}/notificationsPhoneNumber`,
      method: 'PUT',
      body,
    });
  }

  async createMfaVerification(userId: User['id'], body: MfaVerification) {
    return super.write<{ data: never }>({
      endpoint: `/users/${userId}/notificationsPhoneNumberValidate`,
      method: 'POST',
      body,
    });
  }
}

export const AuthUsersApi = new AuthUsersApiClass();
